import React, { FC, Fragment, useEffect, useState } from 'react';

import { LandingPageProps } from './LandingPageProps';

import styles from './LandingPage.module.scss';
import { useAuthActions } from 'auth/useAuthActions';
import { useAuthStatus } from 'auth/useAuthStatus';
import { Button } from '@mui/material';

export const LandingPage: FC<LandingPageProps> = () => {

  const { initiateSignIn, initiateSignOut } = useAuthActions();
  const { isAuthenticated } = useAuthStatus();

  const [loading, setLoading] = useState(true);
  const [redirecting, setRedirecting] = useState(false);

  const loginHandler = async (): Promise<void> => {
    await initiateSignIn();
  }

  useEffect(() => {
    const redirectIfNeeded = async () => {
      if (!isAuthenticated && !redirecting && !loading) {
        setRedirecting(true);
        await loginHandler();
      } else {
        setLoading(false);
      }
    };

    redirectIfNeeded();
  }, [isAuthenticated, redirecting, loading]);

  useEffect(() => {
    setLoading(false);
    return () => setLoading(false);
  }, []);

  return (
    <Fragment>
      <div className={styles.LandingPage} data-testid="LandingPage">
        {loading ? (
          <h1>Loading...</h1>
        ) : (
          <Fragment>
            <h1>Redirecting to Sign In...</h1>
            <Button onClick={loginHandler}>Sign In</Button>
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};
